require("../../../base/js/base-main-custom.js");
require("../../../base/js/tracking-gtm.js");
(function () {
  'use strict';

  window.DGS.GlobalSliderConfig.slideInterval = 10000;
})(jQuery);